import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_label",
  "use": "svg_label-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg_label\"><path d=\"M9.342 0 0 9.342 6.658 16 16 6.658V0H9.342Zm5.654 6.222-8.338 8.365-5.245-5.245L9.76 1.004h5.236v5.218Zm-4-2.222a1.005 1.005 0 1 1 2.01 0 1.005 1.005 0 0 1-2.01 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol